import React, {useEffect, useState} from 'react';

import {Theme} from '@/modules/mantine/themes/lib/theme';

import springboard from 'springboard';

let storedCustomTheme: Theme | null = null;
try {
    const storedString = localStorage.getItem('storedCustomTheme');
    if (storedString) {
        const parsed = JSON.parse(storedString);
        if (parsed?.mantineTheme?.colors?.dark?.[7]) {
            storedCustomTheme = parsed;
        }
    }
} catch (e) {
    console.warn('Invalid theme data in localStorage');
}

springboard.registerSplashScreen(() => {
    const [waited, setWaited] = useState(false);

    useEffect(() => {
        const initialStyle = document.getElementById('initial-background-color-style');
        if (initialStyle) {
            initialStyle.remove();
        }

        setTimeout(() => {
            setWaited(true);
        }, 1000);
    }, []);

    const pageStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: storedCustomTheme?.mantineTheme.colors.dark[7] || 'hsl(210 55% 9%)',
        fontFamily: 'Arial, sans-serif'
    };

    if (!waited) {
        return <div style={pageStyle}/>;
    }

    return (
        <div style={pageStyle}>
            <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#fff',
                marginBottom: '20px'
            }}>
                SongDrive
            </div>
            <div style={{
                width: '200px',
                height: '4px',
                backgroundColor: '#ddd',
                borderRadius: '2px',
                overflow: 'hidden'
            }}>
                <div style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#007acc',
                    borderRadius: '2px',
                    animation: 'loading 1.5s ease-in-out infinite'
                }}></div>
            </div>
            <style>{`
                @keyframes loading {
                    0% { transform: translateX(-100%); }
                    50% { transform: translateX(0%); }
                    100% { transform: translateX(100%); }
                }
            `}</style>
        </div>
    );
});
